import { Align, WalkthroughStep } from "components/WalkthroughGuideCue";
import { validators } from "utils";
import { FilterType, ServerFilters } from "./types";

/**
 * Total number of versions checked by the server. Defined on the backend too, so make sure to update both.
 */
export const VERSION_SEARCH_LIMIT = 300;
export const VERSION_LIMIT = 5;

/* localStorage fields for default filter settings */
export const TASK_FILTER_SETTING_KEY = "task-filter-setting";
export const VARIANT_FILTER_SETTING_KEY = "variant-filter-setting";

export const stringFilterTooltipText =
  "Search is case sensitive. For best performance, use an Exact filter whenever possible.";

export const waterfallPageContainerId = "waterfall-page";

export const waterfallGuideId = "data-waterfall-guide-id";

export const walkthroughSteps: WalkthroughStep[] = [
  {
    title: "New Layout",
    description:
      "We've introduced a new layout for increased information density. Columns are commits, rows are build variants, and squares are tasks.",
    targetId: "task-box",
  },
  {
    title: "Reimagined Task Statuses",
    description:
      "Familiarize yourself with our new task icons using the icon legend at the bottom right.",
    targetId: "task-legend",
    tooltipAlign: Align.End,
  },
  {
    title: "Pin Build Variants",
    description:
      "Pin variants to the top of the page to help with debugging and monitoring common workflows.",
    targetId: "build-variant-pin",
    tooltipAlign: Align.Start,
  },
  {
    title: "Jump to Date",
    description:
      "Use the date picker to find commits from specific dates and track down regressions.",
    targetId: "jump-to-date",
  },
  {
    title: "Search by Git Hash",
    description:
      "Explore other filtering options in the menu, such as search by git hash.",
    targetId: "search-git-hash",
  },
  {
    title: "Summary View",
    description: "A summary of task statuses for any given run.",
    targetId: "summary-view",
    shouldClick: true,
  },
];

export const tupleSelectOptions = [
  {
    value: FilterType.Exact,
    displayName: "Exact",
    validator: () => true,
  },
  {
    value: FilterType.Regex,
    displayName: "Regex",
    validator: validators.validateRegexp,
  },
];

export const resetFilterState: ServerFilters = {
  requesters: undefined,
  statuses: undefined,
  tasks: undefined,
  variants: undefined,
};
